<script type="ts">
  import { flip } from "svelte/animate";

  export let files = Array<File>();

  let list = [
    { name: "foo", id: 0 },
    { name: "bar", id: 1 },
    { name: "bob", id: 2 },
    { name: "jean", id: 3 },
  ];
  let hovering = null;

  function drop(event, target) {
    event.dataTransfer.dropEffect = "move";
    const start = parseInt(event.dataTransfer.getData("text/plain"));
    const newTracklist = files;

    if (start < target) {
      newTracklist.splice(target + 1, 0, newTracklist[start]);
      newTracklist.splice(start, 1);
    } else {
      newTracklist.splice(target, 0, newTracklist[start]);
      newTracklist.splice(start + 1, 1);
    }
    files = newTracklist;
    hovering = null;
  }

  function dragstart(event, i) {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.dropEffect = "move";
    const start = i;
    event.dataTransfer.setData("text/plain", start);
  }

  function dragover(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = "move";
  }

  $: console.log(files);

  function readFileAsync(file) {
    return new Promise<string>((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result.toString());
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  async function getImage(file) {
    const data = await readFileAsync(file);
    return data;
  }
</script>

<!-- <div class="widget image_preview">
  {#each files as file}
    {#await getImage(file) then data}
      <img width="100" src={data} alt={file.name} />
    {/await}
  {/each}
</div> -->

<div class="list">
  {#each files as n, index (n.name)}
    <div
      class="list-item"
      draggable={true}
      on:dragstart={(event) => dragstart(event, index)}
      on:drop|preventDefault={(event) => drop(event, index)}
      on:dragover={dragover}
      on:dragenter={() => (hovering = index)}
      class:is-active={hovering === index}
    >
      {#await getImage(n) then data}
        <img width="100" src={data} alt={n.name} />
      {/await}
    </div>
  {/each}
</div>

<style>
  .list {
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  }

  .list-item {
    display: block;
    padding: 0.5em 1em;
  }

  .list-item:not(:last-child) {
    border-bottom: 1px solid #dbdbdb;
  }

  .list-item.is-active {
    background-color: #3273dc;
    color: #fff;
  }
</style>
